export default {
  namespaced: true,
  state: {
    breadcrumbs: [],
    loadingMe: false,
    calendars: {
      googlecalendar: {
        loading: false
      },
      outlookcalendar: {
        loading: false
      }
    },
    microsoftTeams: {
      isInitialized: false
    },
    newVersionAvailable: false,
    maintenanceEnd: false,
    wasOffline: false,
    lastFocusedTime: new Date().getTime()
  },
  mutations: {
    setBreadcrumbs: function setBreadcrumbs(state, payload) {
      state.breadcrumbs = payload;
    },
    setLoadingMe: function setLoadingMe(state, payload) {
      state.loadingMe = payload;
    },
    setMicrosoftTeamsInitialized: function setMicrosoftTeamsInitialized(state, payload) {
      state.microsoftTeams.isInitialized = payload;
    },
    setNewVersionAvailable: function setNewVersionAvailable(state, payload) {
      state.newVersionAvailable = payload;
    },
    setMaintenanceEnd: function setMaintenanceEnd(state, payload) {
      state.maintenanceEnd = payload;
    },
    setWasOffline: function setWasOffline(state, payload) {
      state.wasOffline = payload;
    },
    setLastFocusedTime: function setLastFocusedTime(state, payload) {
      state.lastFocusedTime = payload;
    },
    setCalendarLoading: function setCalendarLoading(state, payload) {
      state.calendars[payload.calendar].loading = payload.value;
    }
  }
};